import { render, staticRenderFns } from "./FamilyMemberRow.vue?vue&type=template&id=2cc6787b&scoped=true"
import script from "./FamilyMemberRow.vue?vue&type=script&lang=ts"
export * from "./FamilyMemberRow.vue?vue&type=script&lang=ts"
import style0 from "./FamilyMemberRow.vue?vue&type=style&index=0&id=2cc6787b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cc6787b",
  null
  
)

export default component.exports